
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 20V0l1.5 1.5L3 0l1.5 1.5L6 0l1.5 1.5L9 0l1.5 1.5L12 0l1.5 1.5L15 0l1.5 1.5L18 0v20l-1.5-1.5L15 20l-1.5-1.5L12 20l-1.5-1.5L9 20l-1.5-1.5L6 20l-1.5-1.5L3 20l-1.5-1.5L0 20zm3-5h12v-2H3v2zm0-4h12V9H3v2zm0-4h12V5H3v2z"}})])
          )
        }
      }
    